import { render, staticRenderFns } from "./UserWishList.vue?vue&type=template&id=6d6dc78c&scoped=true&"
import script from "./UserWishList.vue?vue&type=script&lang=js&"
export * from "./UserWishList.vue?vue&type=script&lang=js&"
import style0 from "./UserWishList.vue?vue&type=style&index=0&id=6d6dc78c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6dc78c",
  null
  
)

export default component.exports